import { render, staticRenderFns } from "./HelpPanel.vue?vue&type=template&id=48a5c8aa&scoped=true"
import script from "./HelpPanel.vue?vue&type=script&lang=js"
export * from "./HelpPanel.vue?vue&type=script&lang=js"
import style0 from "./HelpPanel.vue?vue&type=style&index=0&id=48a5c8aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a5c8aa",
  null
  
)

export default component.exports